import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-replenishment-closed-list",
    template: `
        <section-warehouse-order-list [state]="state" [type]="'replenishment'"
                                      [status]="'closed'"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderReplenishmentClosedListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-replenishment-closed",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
